/// <reference path="AssetEsperienzeDialog.ts" />

namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeClonableDialog extends Gamification.AssetEsperienzeDialog {
        protected updateInterface() {

            // by default cloneButton is hidden in base UpdateInterface method
            super.updateInterface();

            // here we show it if it is edit mode (not new)
            this.cloneButton.toggle(this.isEditMode());

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                this.cloneButton.hide();
            }
        }

        /**
         * Overriding this method is optional to customize cloned entity
         */
        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            // indicate that this is a clone
            clone.IsCloned = true;

            // add (Clone) suffix if it's not already added
            var suffix = ' [ Clonato ]';
            if (!Q.endsWith(clone.Nome || '', suffix)) {
                clone.Nome = (clone.Nome || '') + suffix;
            }

            // Gestire i campi che non possono essere dei semplici cloni,
            // ad esempio un file associato.
            clone.IdAssetEsperienzaOriginal = this.entityId;
            clone.VersioneAssetBundle = 1;

            clone.TemporaryNomeFileAssetBundle = clone.NomeFileAssetBundle;
            clone.TemporaryPathFileAssetBundle = clone.PathFileAssetBundle;
            clone.TemporaryNomeFileCoverAssetBundle = clone.NomeFileCoverAssetBundle;
            clone.TemporaryPathFileCoverAssetBundle = clone.PathFileCoverAssetBundle;
            clone.TemporaryNomeFileManifestAssetBundle = clone.NomeFileManifestAssetBundle;
            clone.TemporaryPathFileManifestAssetBundle = clone.PathFileManifestAssetBundle;

            return clone;
        }
    }
}